import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

/* ---------------- SIGNUP ---------------- */

export const signupUser = createAsyncThunk(
  "auth/signupUser",
  async (userData) => {

    const res = await fetch(
      "https://api.washim.org/api/users/signup",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json"
        },
        body: JSON.stringify(userData)
      }
    );

    return res.json();

  }
);

/* ---------------- LOGIN ---------------- */

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (userData) => {

    const res = await fetch(
      "https://api.washim.org/api/users/login",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json"
        },
        body: JSON.stringify(userData)
      }
    );

    return res.json();

  }
);

const authSlice = createSlice({

  name: "auth",

  initialState: {

    user:
      JSON.parse(
        localStorage.getItem("user")
      ) || null,

    token:
      localStorage.getItem("token") || null,

    loading: false,

    error: null

  },

  reducers: {

    logoutUser: (state) => {

      state.user = null;

      state.token = null;

      localStorage.removeItem("user");

      localStorage.removeItem("token");

    }

  },

  extraReducers: (builder) => {

    builder.addCase(
      signupUser.pending,
      (state) => {

        state.loading = true;

      }
    );

    builder.addCase(
      signupUser.fulfilled,
      (state, action) => {

        state.loading = false;

      }
    );

    builder.addCase(
      loginUser.pending,
      (state) => {

        state.loading = true;

      }
    );

    builder.addCase(
      loginUser.fulfilled,
      (state, action) => {

        state.loading = false;

        if (action.payload.success) {

          state.user =
            action.payload.user;

          state.token =
            action.payload.token;

          localStorage.setItem(
            "user",
            JSON.stringify(
              action.payload.user
            )
          );

          localStorage.setItem(
            "token",
            action.payload.token
          );

        } else {

          state.error =
            action.payload.message;

        }

      }
    );

  }

});

export const { logoutUser } =
  authSlice.actions;

export default authSlice.reducer;